import http from '../helpers/http';

export default class CardRepository {
    /**
     * Retrieves card information for a card holder based on their scanned QR code.
     * 
     * @param (String) qrCode: the QR Code of the card holder
     * @param (Boolean) includePhoto: If true, the photo is retrieved along with the card data
     */
    getCardDataByQR(qrCode, includePhoto = true, includeFatigueData = false, siteCode = '') {
        return http.post('/api/v1/cards/forCardHolder', { qrCode, includePhoto, includeFatigueData, siteCode })
    }

    /**
     * Retrieves information about a visitor pass based on the scanned QR code.
     * 
     * @param (String) qrCode: The QR code of the scanned visitor pass
     */
    getVisitorPassByQR(qrCode) {
        return http.post('/api/v1/cards/forVisitorPass', { qrCode });
    }

    /**
     * Retrieves fatigue information about an individual based on their card identifier
     * 
     * @param (String) cardSerial The serial number of their card
     */
    getFatigueInformation(cardSerial) {
        return http.post('/api/v1/cards/fatigueInformation', { serialNumber: cardSerial });
    }
}